import { render, staticRenderFns } from "./BulkContracts.vue?vue&type=template&id=8ecbfa5c&"
import script from "./BulkContracts.vue?vue&type=script&lang=js&"
export * from "./BulkContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports